import styled from "styled-components"
import PlayerCard from "./PlayerCard"



const ItemContainer = styled.div`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    padding: 1.25rem 1rem;
    box-sizing: border-box;
`

const PlayerInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 1.25rem;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.625rem;
    align-items: center;
`

const PlayerName = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-weight: 500;
    font-size: 1.5rem;
    color: #000000;
`

const OvrText = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 1.25rem;
    font-weight: 500;
    color: #000000;
`

const TagItem = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-size: 0.875rem;
    font-weight: 300;
    color: #FFFFFF;
    background-color: #545454;
    border-radius: 1rem;
    padding: 0.3125rem 0.75rem;
    display: inline-block;
`

const TagsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    margin-top: 0.3125rem;
`

const StatesGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, auto);
    gap: 0.5rem 1.25rem;
    margin-top: 0.75rem;
` 

const StateItem = styled.div`
    width: 5.75rem;
    font-family: 'Esamanru', sans-serif;
    font-size: 1.125rem;
    font-weight: 400;
    color: #545454;
`

const SetDeckScoreItem = styled(StateItem)`
    margin-top: 0.5rem;
    width: 12rem;
    font-family: 'Esamanru', sans-serif;
    font-size: 1.125rem;
    font-weight: 400;
    color: #545454;
`

export default function SearchResultItem({player, onClick, imageCache, onImageLoaded}) {

    const statesKey = ['s1', 's2', 's3', 's4', 's5', 's6'];
    const statesLabelMap = {
        s1: player.isPitcher? '구속' : '파워',
        s2: player.isPitcher? '변화' : '정확',
        s3: player.isPitcher? '구위' : '선구',
        s4: player.isPitcher? '제구' : '인내',
        s5: player.isPitcher? '지구력' : '주루',
        s6: player.isPitcher? '수비' : '수비'
    } 
    
    return (
        <ItemContainer>
            <PlayerCard
                player={player}
                isForDisplay={true}
                onClick={() => {onClick(player);}}
                cachedImageUrl={imageCache?.[player.playerName]}
                onImageLoaded={onImageLoaded}
            />

            <PlayerInfoContainer>
                <TitleContainer>
                    <PlayerName>{player.type === '임팩트' ? player.description : player.type} {player.playerName}{player.year != null ? ('\''+player.year) : ""}</PlayerName>
                    <OvrText>OVR {player.originalOvr}</OvrText>
                </TitleContainer>

                <TagsContainer>
                    <TagItem>{player.type}</TagItem>
                    {player.description && <TagItem>{player.description}</TagItem>}
                    <TagItem>{player.team}</TagItem>
                    <TagItem>{player.position}</TagItem>
                </TagsContainer>

                <StatesGridContainer>
                    {statesKey.map((key) => (
                        <StateItem key={key}>{statesLabelMap[key]}: {player.originalStates[key]}</StateItem>
                    ))}
                </StatesGridContainer>

                <SetDeckScoreItem>세트덱 스코어 : {player.setDeckScore}</SetDeckScoreItem>

            </PlayerInfoContainer>  

        </ItemContainer>
    )
}